import { h } from 'preact';

const ColorSelector = ({
  colorsToRender,
  clickHandler,
  currentColor,
  overlayImage,
}) => {
  if (!colorsToRender.length) return null;

  const renderedColors = colorsToRender.map((block) => (
    <div
      // eslint-disable-next-line max-len
      className={`relative border border-1 hover:border-gray-900 text-center flex items-center justify-center aspect-square rounded-full transition-all cursor-pointer ${
        currentColor === block.title ? 'border-gray-900' : 'border-transparent'
      }`}
      key={`${block.title}`}
      onClick={() => clickHandler({ title: block.title, hex: block.color })}
    >
      <div
        className={`h-[27.6px] aspect-square rounded-full ${
          block.color === '#ffffff' && 'border border-1 border-[#CCCCCC]'
        }`}
        style={{ backgroundColor: block.color }}
      ></div>
      {overlayImage && (
        <div
          className="h-[27.6px] aspect-square rounded-full absolute"
          style={{
            // eslint-disable-next-line max-len
            backgroundImage: `url("${overlayImage}")`,
          }}
        ></div>
      )}
    </div>
  ));

  return (
    <div className="border border-1 border-x-0 border-t-0 border-gray-300 pb-5 mb-5">
      <div className="body-3 mb-2.5">
        Thread color: <span className="font-medium">{currentColor}</span>
      </div>
      <div className="grid grid-cols-7 gap-2 mb-3.5">{renderedColors}</div>
    </div>
  );
};

export default ColorSelector;
